import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { BookingCalendarView } from '~/components/admin/bookings/list-booking/components/booking-calendar-view';

export const CalendarPopup: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [initialDate] = useState(() => {
    const dateParam = searchParams.get('date');
    return dateParam ? dayjs(dateParam) : dayjs();
  });

  // Set page title
  useEffect(() => {
    document.title = 'Calendar View - Art Handler';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <BookingCalendarView
        setViewMode={() => {}}
        bookings={[]}
      />
    </div>
  );
};
